/* eslint-disable */
export const MINDWORKING_REDIRECT_TYPES = {
    MW_FAVORITE_PROPERTY: 'mwFavoriteProperty',
    MW_SEARCH_AGENT: 'mwSearchAgent',
} as const;
